module.exports = __webpack_public_path__ + "img/applications.4e2b116f.svg";